import { useCanAccess } from "./useCanAccess";

// Renders children only when the current user holds at least one of
// requiredRole (any-of). Otherwise renders nothing.
//
// Use for JSX that is NOT a direct child of a react-router <Switch> —
// nav items, buttons, sections. For routes inside <Switch>, gate with
// the useCanAccess boolean instead: Switch matches by inspecting the
// direct <Route>'s path prop, so wrapping a Route breaks matching.
//
// Props:
//   requiredRole: string | string[] — role(s); any-of grants access.
const RoleGuard = ({ requiredRole, children }) => {
  const canAccess = useCanAccess(requiredRole);
  return canAccess ? children : null;
};

export default RoleGuard;
